export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/eZSqpLTmUsn6QMA5UoS4JG/IMG_2711.jpg',
    alt: 'Sample page A Data Center Is a Power and Cooling Facility, showing electrical systems, backup power, cooling, IT equipment, monitoring and physical security',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/3Ndo8ZeSvwkNEqHzLAtLSr/IMG_2712.jpg',
    alt: 'Sample page Follow the Power from Utility to Server, tracing utility supply, switchgear, transformer, UPS, PDU, remote power panel and rack PDU',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/qeKkBMcjNmiW54u3yqnRPE/IMG_2713.jpg',
    alt: 'Sample page 2N: Two Complete Systems, explaining system redundancy with its benefits and trade-offs',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/17L1XQdnXSnFgCbkmS1uV3/IMG_2714.jpg',
    alt: 'Sample page The Facility Is Watched 24 Hours a Day, comparing BMS, EPMS and DCIM monitoring systems',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/4Wi6SC9qVi85ZUv5XDJNSE/IMG_2715.jpg',
    alt: "Sample page Trace One Server's Power and Heat, a practical case following the power path and the heat removal path",
  },
];
